import { forgotPasswordSchema } from "@closer/shared";
import { Button, Card, FormField, Input, useToast } from "@closer/ui";
import { useState } from "react";
import { Link } from "react-router";
import type { z } from "zod";

import { api, ApiRequestError } from "../../lib/apiClient";
import { applyServerErrors, useZodForm } from "../../lib/useZodForm";

type ForgotValues = z.infer<typeof forgotPasswordSchema>;

export function ForgotPasswordPage() {
  const toast = useToast();
  const [sentMessage, setSentMessage] = useState<string | null>(null);
  const form = useZodForm(forgotPasswordSchema, {
    defaultValues: { email: "" } as ForgotValues,
  });

  const onSubmit = form.handleSubmit(async (values) => {
    try {
      const { data } = await api<{ message: string }>("/api/session/forgot-password", {
        method: "POST",
        body: JSON.stringify(values),
      });
      setSentMessage(data.message);
    } catch (error) {
      applyServerErrors(form, error);
      toast.error(
        error instanceof ApiRequestError
          ? error.message
          : "İşlem tamamlanamadı. Lütfen tekrar deneyin.",
      );
    }
  });

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <Card title="Şifremi Unuttum" className="w-full max-w-sm">
        {sentMessage ? (
          <div className="flex flex-col gap-4">
            <p role="status" className="text-sm text-slate-600">
              {sentMessage}
            </p>
            <Link to="/login" className="text-center font-medium text-primary hover:underline">
              Giriş sayfasına dön
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} noValidate className="flex flex-col gap-4">
            <p className="text-sm text-slate-500">
              Hesabınızın e-posta adresini girin; sıfırlama bağlantısını gönderelim.
            </p>
            <FormField label="E-posta" error={form.formState.errors.email?.message} required>
              <Input type="email" autoComplete="email" {...form.register("email")} />
            </FormField>
            <Button type="submit" loading={form.formState.isSubmitting}>
              Sıfırlama Bağlantısı Gönder
            </Button>
            <p className="text-center text-sm text-slate-500">
              <Link to="/login" className="font-medium text-primary hover:underline">
                Giriş sayfasına dön
              </Link>
            </p>
          </form>
        )}
      </Card>
    </div>
  );
}
